import { useState } from "preact/hooks";
import { requests } from "../api/handleRequest";
import axiosClient from "../api/client";
import store from "../store";
import { modalConfig } from "../actionTypes";
import axios from "axios";

export default () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [errorBody, setErrorBody] = useState(null);
  const [loading, setLoading] = useState(false);

  const request = async (requestConfig) => {
    if (
      requestConfig.path &&
      requestConfig.path.trim() &&
      requestConfig.method &&
      requestConfig.method.trim()
    ) {
      setLoading(true);
      setError("");
      setErrorBody(null);
      try {
        const result = await requests(requestConfig, axiosClient);
        setData(result);
      } catch (err) {
        setError(err?.response?.data?.ui_err_msg || "Unexpected Error!");
        setErrorBody(err);
        if (axios.isCancel(err) || err?.response == null) {
          store.dispatch({ type: modalConfig.OPEN_REFRESH_MODAL });
        }
      } finally {
        setLoading(false);
      }
    }
  };

  return {
    data,
    error,
    setError,
    loading,
    request,
    errorBody,
  };
};
